export const CSV_ROW_LIMIT = 1000;

export const PERMISSION_TYPES = {
	SINGLE_PERMISSION: 'singlePermission',
	PERMISSION_SET: 'permissionSet'
} as const;

export const REQUEST_STATUS = {
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED'
} as const;

export const ITEM_STATUS = {
	PENDING: 'PENDING',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE'
} as const;

export const CSV_HEADERS = {
	EMAIL: 'email',
	PERMISSION_NAME: 'permission name',
	ACTION: 'action',
	EXPIRE_AFTER_SEC: 'expire after sec',
	IS_MASKED: 'is masked'
} as const;

export const CSV_ACTIONS = {
	ASSIGN: 'Assign',
	REMOVE: 'Remove'
} as const;

export const FORM_FIELD_KEYS = {
	DESCRIPTION: 'description',
	PERMISSION_TYPE: 'permissionType',
	CSV_FILE: 'csvFile'
} as const;

export const TABLE_COLUMNS = {
	CSV_PREVIEW: ['Index', 'Email', 'Permission Name', 'Action', 'Expire After (Sec)', 'Is Masked']
} as const;

export const PERMISSION_TYPE_OPTIONS = [
	{ id: PERMISSION_TYPES.SINGLE_PERMISSION, label: 'Single Permission' },
	{ id: PERMISSION_TYPES.PERMISSION_SET, label: 'Permission Set' }
];

export const API_ENDPOINTS = {
	LIST_REQUESTS: '/dashboard/forward/permissionsManagement-bulkPermissionCsv-listBulkPermissionRequests',
	CREATE_REQUEST: '/dashboard/forward/permissionsManagement-bulkPermissionCsv-createBulkPermissionRequest',
	CHECK_STATUS: '/dashboard/forward/permissionsManagement-bulkPermissionCsv-checkBulkPermissionRequestStatus'
} as const;

export const PAGINATION = {
	DEFAULT_PAGE_SIZE: 20,
	STATUS_PAGE_SIZE: 50,
	CSV_PREVIEW_LIMIT: 100
} as const;

export const PLACEHOLDERS = {
	DESCRIPTION: 'Provide a description for this bulk permission request',
	PERMISSION_TYPE: 'Select whether you are assigning single permissions or permission sets',
	CSV_FILE: `Upload a CSV file with columns: Email | Permission Name | Action | Expire After Sec | Is Masked (max ${CSV_ROW_LIMIT} rows)`
} as const;

export const STATUS_COLORS = {
	[REQUEST_STATUS.COMPLETED]: '#28a745',
	[REQUEST_STATUS.FAILED]: '#dc3545',
	[REQUEST_STATUS.IN_PROGRESS]: '#ffc107',
	[ITEM_STATUS.SUCCESS]: '#28a745',
	[ITEM_STATUS.FAILURE]: '#dc3545',
	[ITEM_STATUS.PENDING]: '#ffc107',
	DEFAULT: '#6c757d'
} as const;

export const MESSAGES = {
	UPLOAD_SUCCESS: (count: number) => `Successfully parsed ${count} rows from CSV`,
	UPLOAD_ERROR: 'Failed to parse CSV file',
	CREATE_SUCCESS: 'Bulk permission request created successfully',
	CREATE_ERROR: 'Failed to create bulk permission request',
	FETCH_ERROR: 'Error fetching requests',
	STATUS_ERROR: 'Error fetching status details',
	VALIDATION: {
		DESCRIPTION_REQUIRED: 'Please enter a description',
		PERMISSION_TYPE_REQUIRED: 'Please select a permission type',
		CSV_FILE_REQUIRED: 'Please upload a valid CSV file',
		CSV_EMPTY: 'CSV file is empty',
		CSV_NO_DATA: 'No valid data rows found in CSV',
		CSV_ROW_LIMIT_EXCEEDED: `CSV contains more than ${CSV_ROW_LIMIT} rows. Please reduce the number of rows.`,
		CSV_INVALID_HEADERS:
			'CSV headers do not match expected format: Email | Permission Name | Action | Expire After Sec | Is Masked',
		FILE_READ_ERROR: 'Failed to read file'
	},
	INVALID_ROW_REASONS: {
		MISSING_REQUIRED_FIELDS: 'Missing required fields',
		INVALID_EMAIL: 'Invalid email',
		INVALID_ACTION: 'Invalid action',
		INVALID_EXPIRE_AFTER: 'Invalid expireAfter value',
		INVALID_IS_MASKED: 'Invalid isMasked value'
	}
} as const;

export const ROUTES = {
	LIST: '/',
	CREATE: '/create'
};

export const ENTITIES = {
	BULK_PERMISSIONS_CSV: 'BULK_PERMISSIONS_CSV',
	BULK_PERMISSIONS_CSV_STATUS: 'BULK_PERMISSIONS_CSV_STATUS'
} as const;

export const FORWARD_ROUTES = {
	LIST_REQUESTS: '/dashboard/bulkPermissionCsv/listBulkPermissionRequests',
	CHECK_STATUS: '/dashboard/bulkPermissionCsv/checkBulkPermissionRequestStatus',
	CREATE_REQUEST: '/dashboard/bulkPermissionCsv/createBulkPermissionRequest'
} as const;

export const LIST_COL_NAMES = {
	REQUESTER_EMAIL: 'requesterEmail',
	DESCRIPTION: 'description',
	PERMISSION_TYPE: 'permissionType',
	STATUS: 'status',
	CREATED_AT: 'createdAt',
	TOTAL_ROWS: 'totalRows',
	PROCESSED_ROWS: 'processedRows',
	SUCCESS_COUNT: 'successCount',
	FAILURE_COUNT: 'failureCount'
} as const;

export const STATUS_COL_NAMES = {
	USER_EMAIL: 'userEmail',
	PERMISSION: 'permission',
	ACTION: 'action',
	STATUS: 'status',
	PROCESSED_AT: 'processedAt',
	REMARK: 'remark'
} as const;
